import { useLazyQuery } from '@apollo/client';
import { ITextFieldProps } from '@fluentui/react';
import { RequiredNameProps } from 'common/types/utility';
import {
  RefCode2,
  RefCode2Variables,
} from 'documents/documentAssignment/folder/view/FormView/AccountingView/CustomFields/AutoCompleteRefCode2/__generated__/RefCode2';
import { DocumentNode } from 'graphql';
import React, { useRef, useState } from 'react';
import { ColumnData } from '../../columns.data';
import { AutoCompleteFF, refType } from '../AutoCompleteFF';
import { InvoiceDetails_invoice_invoiceDistributions_nodes } from '../../../graphql/__generated__/InvoiceDetails';

import REFERENCE_CODE2 from '../../../../../../graphql/Reference2Codes.graphql';
export type AutoCompleteFFTextFieldProps =
  RequiredNameProps<ITextFieldProps> & {
    index: number;
    invoiceDistributions:
      | InvoiceDetails_invoice_invoiceDistributions_nodes[]
      | undefined;
    query?: DocumentNode;
    columnData?: ColumnData;
  };

export const AutoCompleteFF2: React.FC<AutoCompleteFFTextFieldProps> = ({
  columnData,
  index,
  ...props
}) => {
  const ref = useRef<refType>();
  const [fieldValue, setFieldValue] = useState<string | null>(null);
  const [fetchReferenceCodes, { data, loading }] = useLazyQuery<
    RefCode2,
    RefCode2Variables
  >(REFERENCE_CODE2, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-only',
    onCompleted: (data) => {
      if (data.reference2Codes?.nodes.length) {
        const position = data.reference2Codes.nodes.findIndex(
          (item) =>
            item.referenceCode.toUpperCase() === fieldValue?.toUpperCase()
        );
        if (position === -1) {
        } else ref?.current?.onClearFieldValue();
      } else ref?.current?.onClearFieldValue();
    },
  });
  return (
    <>
      <AutoCompleteFF
        width={columnData?.maxWidth}
        id={`${columnData?.key}${index}`}
        onValueChange={(data) => {
          setFieldValue(data);
          fetchReferenceCodes({
            variables: {
              Ref2CodeFilter: {
                referenceCode: {
                  startsWithInsensitive: data,
                },
              },
            },
          });
        }}
        ffValue={props.invoiceDistributions?.[index]?._ff2Name}
        index={index}
        {...props}
        loading={loading}
        referenceCodeData={data?.reference2Codes?.nodes}
        ref={ref}
      />
    </>
  );
};
